import { useState } from 'react'

import { notifyMethod } from '../../../App'
import useRouter from '../../../hooks/useRouter'
import { getUserData } from '../../../utils'
import { include, isEqual } from '../../../utils/javascript'
import { generateMasterSheetApi } from '../../jobs/jobs.api'
import { payloadType } from '../../jobs/jobs.description'
import { userChildrenList } from '../../layout/sidebar.description'
import { roleIdByPath, userTranslationKey } from '../user.description'

const userManagement = () => {
  const { params, location, navigate } = useRouter()
  const { userType } = params
  const pathRoleId = roleIdByPath[userType]
  const userTitle = pathRoleId && userTranslationKey[pathRoleId]
  const { userData } = getUserData()
  const { roleId, adminId } = { ...userData }
  let permission = false
  const userViewObj = userChildrenList.find(v =>
    isEqual(v?.userId, roleId),
  )?.userView
  const currentUserView = userViewObj?.[userTitle]
  const defaultPayload = { roleId: pathRoleId }

  const [excelLoader, setExcelLoader] = useState(false)
  const [viewRequestsModal, setViewRequestsModal] = useState({ open: false })

  userChildrenList.forEach(value => {
    if (isEqual(value?.label, userTitle)) {
      permission = include(value.addEdit, roleId)
    }
  })

  const handleAdd = () => {
    navigate(`${location.pathname}/add`)
  }

  const onExportToExcel = async () => {
    setExcelLoader(true)
    const payload = { type: payloadType?.['anganwadiListSheet'] }
    const resp = await generateMasterSheetApi({ payload })
    if (resp?.data?.success) {
      notifyMethod.success({
        message: 'msg_ReportGenerated',
      })
    }
    setExcelLoader(false)
  }

  const onViewPreviousRequests = () => {
    setViewRequestsModal(prev => ({ ...prev, open: !prev.open }))
  }

  return {
    adminId,
    userTitle,
    permission,
    defaultPayload,
    currentUserView,
    handleAdd,
    onExportToExcel,
    onViewPreviousRequests,
    viewRequestsModal,
    excelLoader,
  }
}

export default userManagement
